"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectSelectedTransformModes = void 0;
/* eslint-disable import/prefer-default-export */
const reselect_1 = require("reselect");
exports.selectSelectedTransformModes = (0, reselect_1.createSelector)((state) => state.transformModes, (transformModes) => transformModes.selectedTransformMode);
